<template>
  <div class="login_container">
    <div class="login_content">
      <div class="logo_div">
        <img :src="bosumLogo" alt="logo" />
      </div>
      <h3>登录</h3>
      <div class="login_form_div">
        <div class="inner">
            <div
              class="international-mobile-text"
              @click="internationalMobileShow = true"
            >
              <span>+{{areaCode}}</span>
              <img
                class="international-mobil-img"
                src="../../static/img/to-b-icon.png"
              />
            </div>
          <el-input v-model="myMobile" :maxlength="areaCode == '86'?'11':'15'"></el-input>
        </div>
      </div>
    </div>
    <div class="login_bottom">
      <button @click="loginFun">立即登记</button>
    </div>

     <mt-popup
      v-model="internationalMobileShow"
      position="right"
      style="height: 100%; width: 100%"
    >
      <div class="international-heade">
        <div class="international-title">
          <img
            @click="internationalMobileShow = false"
            src="../../static/img/go-left.png"
          />
          <div>选择国家/地区</div>
        </div>
        <div class="international-input">
          <el-input
            class="international-input-border"
            label=""
            placeholder="请输入国家/地区名查询"
            v-model="queryStr"
          >
           <el-button slot="append" icon="el-icon-search" @click="getErpCountryInfoPhoneList">搜索</el-button>
          </el-input>
        </div>
      </div>

      <div class="login-index-list">
        <mt-index-list>
          <mt-index-section
            v-for="(item, index1) in countryInfoPhoneList"
            :key="index1"
            :index="item.firstEn"
          >
            <mt-cell
              v-for="(i, index2) in item.infoModelList"
              :key="index2"
              :title="i.nameCn+'+'+i.countryCode "
              @click.native="infoModelData(i.countryCode)"
            >
            </mt-cell>
          </mt-index-section>
        </mt-index-list>
      </div>
    </mt-popup>
  </div>
</template>

<script>
import bosumLogo from "@/assets/bosum-logo.png";
import Common from "@/utils/common";
import { getUrlParam } from "@/utils/utils";
import customerService from "@/api/customerService";

export default {
  name: "loginCopy",
  data: function () {
    return {
      bosumLogo,
      activityId: "",
      myMobile: "",
      countryInfoPhoneList:[],
      areaCode:'86',
      internationalMobileShow:false,
      queryStr:''
    };
  },
  mounted() {
    var vm = this;
    vm.activityId = getUrlParam("activityId");
    console.log(vm.activityId);
    vm.getErpCountryInfoPhoneList()
  },
  methods: {
    getErpCountryInfoPhoneList() {
      var vm = this;
      customerService.getErpCountryInfoPhoneList(this).then(function (data) {
          for (var i = 0; i < data.length; i++) {
              if (data[i].firstEn === "hot") {
                  var obj = data.splice(i, 1);
                  obj[0].firstEn = "热门";
                  break;
              }
          }
          data.unshift(obj[0]);
          vm.countryInfoPhoneList = data;
      });
    },
      infoModelData(val){
      this.areaCode = val
      this.internationalMobileShow = false
       },
    loginFun: function () {
      var vm = this;
      if (Common.Util.isEmpty(vm.myMobile)) {
        Common.PageOperator.showPromptMsg(
          vm,
          true,
          "请填写手机号码",
          "warning"
        );
        return;
      }
      if(!Common.Util.isMobileCode(vm.areaCode,vm.myMobile)){
        Common.PageOperator.showPromptMsg(
          vm,
          true,
          "请输入正确的手机号",
          "warning"
        );
        return;
      }
      // if (!Common.Util.isMobile(vm.myMobile)) {
      //   Common.PageOperator.showPromptMsg(
      //     vm,
      //     true,
      //     "手机号码格式错误，请重新填写",
      //     "warning"
      //   );
      //   return;
      // }
      customerService
        .getInformationVO(vm, vm.activityId, vm.myMobile,vm.areaCode)
        .then(function (data) {
          vm.$eventBus.$emit("userInfo", data);
          vm.$router.push({
            path: "/profile",
            query: { activityId: vm.activityId, mobile: vm.myMobile,areaCode:vm.areaCode },
          });
        });
    },
  },
};
</script>

<style scoped>
.login_container {
  padding: 50px 30px 0;
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.login_content {
}

.login_content > h3 {
  letter-spacing: 1px;
  font-size: 24px;
  margin-bottom: 15px;
  font-weight: normal;
  color: #000;
}

.login_content > p {
  font-size: 18px;
  margin-bottom: 20px;
}

.logo_div {
  margin-bottom: 10px;
}

.logo_div > img {
  width: 160px;
}

.login_form_div {
  width: 100%;
  height: 50px;
  background: #ffffff;
  box-shadow: 0px 5px 6px 0px rgba(0, 0, 0, 0.06);
}

.login_form_div > .inner {
  border-bottom: 1px solid #eee;
  margin: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}

.login_form_div > .inner > span {
  border-right: 1px solid #eee;
  width: 50px;
  display: inline-block;
  text-align: center;
  height: 28px;
  line-height: 28px;
}

.login_bottom {
  width: 100%;
  margin-top: 50px;
}

.login_bottom > button {
  width: 100%;
  height: 46px;
  background: #d43d3d;
  color: #fff;
  font-size: 18px;
  box-shadow: 0px 5px 6px 0px rgba(212, 61, 61, 0.6);
  border: none;
  border-radius: 3px;
}

 /deep/.international-mobile>.el-form-item__content{
    display: flex;
    justify-content: space-between;
}

.mint-indexsection-index{
    font-weight: 800;
}
.stem-weight{
font-weight: 800;
}
.international-mobile-text{
    color: #666;
    font-size: 15px;
    width: 80px;
}
.international-mobil-img{
    width: 11px;
    height: 7px;
}
  .international-heade{
    padding: 10px 15px;
    position: fixed;
    width: 100%;
    height: 110px;
}
.international-title{
   display: flex;
   align-items: center;
   justify-content: center;
   position: relative;
   font-size: 18px;
   font-weight: 800;
}
.international-title>img{
    width: 23px;
    position: absolute;
    left: 0;
}
.international-input-border{
    margin-right: 20px;
    margin-top: 10px;
    border-radius: 10px;
}
.login-index-list{
    margin-top: 110px;
    margin-left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/loginCopy.vue